<app-navbar #navbar [class.hidden]="scroll.navbarHidden()"></app-navbar>
<app-dock #appDock [class.hidden]="scroll.dockHidden()"></app-dock>
<div class="container">
  <div class="box">
    <div class="face home" [ngClass]="{'active': (activeFaces$ | async)?.home}">
      <app-home (toggleImprint)="toggleImprint()" (togglePrivacy)="togglePrivacyPolicy()"></app-home>
    </div>

    <div class="face about" [ngClass]="{'active': (activeFaces$ | async)?.about}">
      <app-about-us (toggleImprint)="toggleImprint()" (togglePrivacy)="togglePrivacyPolicy()"></app-about-us>
    </div>

    <div class="face resume" [ngClass]="{'active': (activeFaces$ | async)?.resume}">
      <app-resume (toggleImprint)="toggleImprint()" (togglePrivacy)="togglePrivacyPolicy()"></app-resume>
    </div>

    <div class="face portfolio" [ngClass]="{'active': (activeFaces$ | async)?.portfolio}">
      <app-portfolio (toggleImprint)="toggleImprint()" (togglePrivacy)="togglePrivacyPolicy()"></app-portfolio>
    </div>

    <div class="face blog" [ngClass]="{'active': (activeFaces$ | async)?.blog}">
      <app-blog (toggleImprint)="toggleImprint()" (togglePrivacy)="togglePrivacyPolicy()"></app-blog>
    </div>

    <div class="face contact" [ngClass]="{'active': (activeFaces$ | async)?.contact}">
      <app-contact (toggleImprint)="toggleImprint()" (togglePrivacy)="togglePrivacyPolicy()"></app-contact>
    </div>
  </div>
</div>

<!-- LIGHT IMPRINT -->
<div id="imprintOverlay" class="overlay overlay-imprint overlay-variant-light"
  [class.visible]="(overlayState.state$ | async)?.overlays.imprint.visible"
  [class.expand]="(overlayState.state$ | async)?.overlays.imprint.phase === 'expanding'"
  [class.expanded]="(overlayState.state$ | async)?.overlays.imprint.phase === 'expanded'"
  [class.shrink]="(overlayState.state$ | async)?.overlays.imprint.phase === 'shrinking'"
  [class.on-top]="(overlayState.state$ | async)?.overlays.imprint.activeVariant === 'light'" [class.wipe]="(overlayState.state$ | async)?.overlays.imprint.visible
           && (overlayState.state$ | async)?.overlays.imprint.activeVariant === 'light'
           && (overlayState.state$ | async)?.overlays.imprint.wipeNonce
              !== (overlayState.state$ | async)?.overlays.imprint.wipeSeenNonce"
  (animationend)="onOverlayRootAnimEnd('imprint', 'light', $event)">
  <div #imprintLightContent class="overlay-content"
    (animationend)="onOverlayAnimEnd('imprint', 'light', $event, imprintLightContent)">
    <div class="overlay-scroll">
      <app-imprint></app-imprint>
    </div>
    <div class="close-btn-wrapper overlay-btn-wrapper">
      <button class="close-btn overlay-btn" (click)="overlayState.close('imprint')">✕</button>
    </div>
  </div>
</div>

<!-- DARK IMPRINT -->
<div id="dark-container-imprintOverlay" class="overlay overlay-imprint overlay-variant-dark"
  [class.visible]="(overlayState.state$ | async)?.overlays.imprint.visible"
  [class.expand]="(overlayState.state$ | async)?.overlays.imprint.phase === 'expanding'"
  [class.expanded]="(overlayState.state$ | async)?.overlays.imprint.phase === 'expanded'"
  [class.shrink]="(overlayState.state$ | async)?.overlays.imprint.phase === 'shrinking'"
  [class.on-top]="(overlayState.state$ | async)?.overlays.imprint.activeVariant === 'dark'" [class.wipe]="(overlayState.state$ | async)?.overlays.imprint.visible
           && (overlayState.state$ | async)?.overlays.imprint.activeVariant === 'dark'
           && (overlayState.state$ | async)?.overlays.imprint.wipeNonce
              !== (overlayState.state$ | async)?.overlays.imprint.wipeSeenNonce"
  (animationend)="onOverlayRootAnimEnd('imprint', 'dark', $event)">
  <div #imprintDarkContent class="overlay-content"
    (animationend)="onOverlayAnimEnd('imprint', 'dark', $event, imprintDarkContent)">
    <div class="overlay-scroll">
      <app-imprint></app-imprint>
    </div>

    <div class="close-btn-wrapper overlay-btn-wrapper">
      <button class="close-btn overlay-btn" (click)="overlayState.close('imprint')">✕</button>
    </div>
  </div>
</div>

<!-- LIGHT PRIVACY -->
<div id="privacyPolicyOverlay" class="overlay overlay-privacy overlay-variant-light"
  [class.visible]="(overlayState.state$ | async)?.overlays.privacy.visible"
  [class.expand]="(overlayState.state$ | async)?.overlays.privacy.phase === 'expanding'"
  [class.expanded]="(overlayState.state$ | async)?.overlays.privacy.phase === 'expanded'"
  [class.shrink]="(overlayState.state$ | async)?.overlays.privacy.phase === 'shrinking'"
  [class.on-top]="(overlayState.state$ | async)?.overlays.privacy.activeVariant === 'light'" [class.wipe]="(overlayState.state$ | async)?.overlays.privacy.visible
           && (overlayState.state$ | async)?.overlays.privacy.activeVariant === 'light'
           && (overlayState.state$ | async)?.overlays.privacy.wipeNonce
              !== (overlayState.state$ | async)?.overlays.privacy.wipeSeenNonce"
  (animationend)="onOverlayRootAnimEnd('privacy', 'light', $event)">
  <div #privacyLightContent class="overlay-content"
    (animationend)="onOverlayAnimEnd('privacy', 'light', $event, privacyLightContent)">
    <div class="overlay-scroll">
      <app-privacy-policy></app-privacy-policy>
    </div>
    <div class="close-btn-wrapper overlay-btn-wrapper">
      <button class="close-btn overlay-btn" (click)="overlayState.close('privacy')">✕</button>
    </div>
  </div>
</div>

<!-- DARK PRIVACY -->
<div id="dark-container-privacyPolicyOverlay" class="overlay overlay-privacy overlay-variant-dark"
  [class.visible]="(overlayState.state$ | async)?.overlays.privacy.visible"
  [class.expand]="(overlayState.state$ | async)?.overlays.privacy.phase === 'expanding'"
  [class.expanded]="(overlayState.state$ | async)?.overlays.privacy.phase === 'expanded'"
  [class.shrink]="(overlayState.state$ | async)?.overlays.privacy.phase === 'shrinking'"
  [class.on-top]="(overlayState.state$ | async)?.overlays.privacy.activeVariant === 'dark'" [class.wipe]="(overlayState.state$ | async)?.overlays.privacy.visible
           && (overlayState.state$ | async)?.overlays.privacy.activeVariant === 'dark'
           && (overlayState.state$ | async)?.overlays.privacy.wipeNonce
              !== (overlayState.state$ | async)?.overlays.privacy.wipeSeenNonce"
  (animationend)="onOverlayRootAnimEnd('privacy', 'dark', $event)">
  <div #privacyDarkContent class="overlay-content"
    (animationend)="onOverlayAnimEnd('privacy', 'dark', $event, privacyDarkContent)">
    <div class="overlay-scroll">
      <app-privacy-policy></app-privacy-policy>
    </div>
    <div class="close-btn-wrapper overlay-btn-wrapper">
      <button class="close-btn overlay-btn" (click)="overlayState.close('privacy')">✕</button>
    </div>
  </div>
</div>
